// La regla de los navegadores para <input type="email"> (WHATWG), más un punto en
// el dominio como pide el backend (email.ValidarDestinatario). Acepta +, puntos,
// guiones y subdominios: ana.perez+entradas@mail.empresa.com.ar
const PATRON =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export const esEmailValido = (valor) => {
  const email = (valor ?? "").trim();
  if (email.length > 254) return false;
  const [local = ""] = email.split("@");
  return local.length <= 64 && PATRON.test(email);
};
